/**
 * GET `admin/trial-features` — каталог прав с флагом inTrial (что доступно
 * клинике на 30-дневном триале). Группировка по groupKey — на фронте.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_TRIAL_FEATURES} from '../mocks';
import {toTrialFeatures} from '../toTrialFeatures';
import type {TrialFeature} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getTrialFeatures = async (): Promise<TrialFeature[]> => {
  if (!apiEnabled) {
    await sleep(240);
    return MOCK_TRIAL_FEATURES.map((f) => ({...f}));
  }

  const raw = await http<Record<string, unknown>>('admin/trial-features', {
    skipCaseConversion: true,
  });
  return toTrialFeatures(raw);
};
